<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-icon v-if="!isAuthorized" x-large>lock</v-icon>
            <span v-else class="display-1 grey--text">Добро пожаловать в административную панель</span>
        </v-layout>
    </v-container>
</template>

<script>
import { AuthChecker as isAuth } from "./../utils";

export default {
  computed: {
    isAuthorized() {
      return isAuth();
    }
  }
};
</script>
